import React from "react";
import styles from "./styles/horizontal-span.module.scss";

const HorizontalSpan = () => (
  <div className={styles.horizontal_span}>
    <span>or by email</span>
  </div>
);

export default HorizontalSpan;
